import { scrollToComments } from "../utilities";
/**
 * Generate the list entry popup
 * This is used to check if there's an id in the URL and if there is the popup opens by default
 * @param {*} mapView
 * @param {*} pinLayer
 */
export const generateListEntryPopup = async (mapView, pinLayer) => {
    // Get search parameter id
    let searchParams = new URLSearchParams(window.location.search);
    let externalId = searchParams.get('id');

    // Get the graphics
    if (pinLayer.graphics.items.length > 0) {
        // Find the graphic that matches the external ID
        let graphic = pinLayer.graphics.items.find(graphic => graphic.getAttribute('externalId') == externalId);

        // If the graphic exists then open the popup
        if(graphic) {
            //Open the popup
            mapView.popup.open({
                features: [graphic],
                location: graphic.geometry,
            });

            //Center the map based on the location of the popup
            mapView.goTo({
                center: graphic.geometry
            })
        }
    }
};

/**
* Create the popup content
* @param {*} commentCount 
* @param {*} imageUrl 
* @param {*} addressFound 
* @param {*} name 
* @param {*} feature 
* @returns 
*/
export const createPopupContent = (commentCount, imageUrl, addressFound, name, isActive, isUserLoggedIn, signInRedirect, loadImages, feature) => {
    let firstComment = false;
    const containerDiv = document.createElement("div");
    let textDiv = document.createElement("div");
    let contentDiv = document.createElement("div");

    textDiv.classList.add('ugc__map-popup-content');
    textDiv.classList.add('he-grid-col-12');
    contentDiv.classList.add('he-grid-row');
    containerDiv.classList.add('ugc__map-popup-overflow');

    if(feature) {
        // Create the heritage category div
        const heritageCategoryDiv = document.createElement("div");
        heritageCategoryDiv.innerHTML = `Heritage Category: <strong> ${feature.graphic.attributes.Heritage_Category} </strong>`;
        textDiv.appendChild(heritageCategoryDiv);

        // Create the grade div
        const gradeDiv = document.createElement("div");

        // if there is no grade then set text to "Not applicable"
        gradeDiv.innerHTML = `Grade: <strong> ${feature.graphic.attributes.Grade === undefined ? "Not applicable" : feature.graphic.attributes.Grade} </strong>`;
        textDiv.appendChild(gradeDiv);

        // Create the list entry number div
        const listEntryNumberDiv = document.createElement("div");
        listEntryNumberDiv.innerHTML = `List Entry Number: <strong> ${feature.graphic.attributes.List_Entry_Number} </strong>`;
        textDiv.appendChild(listEntryNumberDiv);
    }

    if (addressFound) {
        let commentLinkHref;
        let commentLinkText;

        if (
            isActive &&
            addressFound &&
            (commentCount === 0 || commentCount === undefined)
        ) {            
            firstComment = true;
            commentLinkHref = !isUserLoggedIn ? signInRedirect : '#';
            commentLinkText = 'Be the first to comment';
        } else {
            commentLinkHref = '#showingCommentsMessage';
            commentLinkText = `View comments (${commentCount})`;
        }

        const addCommentDiv = document.createElement("div");
        // If comments exist, link scrolls down. If not, link directs to sign-in
        !firstComment ? addCommentDiv.innerHTML += `<div><a class="list-entry-link-ugc" id="scrollFrom">${commentLinkText}</a></div>` : addCommentDiv.innerHTML += `<div><a class="list-entry-link-ugc" href="${commentLinkHref}">${commentLinkText}</a></div>`;
        
        addCommentDiv.addEventListener('click', function(e) {
            // If there is an id then call the scroll to comments method
            if(e.target.id){
                scrollToComments();
            }
        });
        
        // If it's not the first comment then we want to add an additional link, as the first link will be for Viewing Comments
        if(!firstComment) {
            isUserLoggedIn ?
                addCommentDiv.innerHTML += `<a class="add-comment-link-ugc" href="#">Add a comment</a></div>` :
                addCommentDiv.innerHTML += `<a class="sign-in-link-ugc" href=${signInRedirect}>Sign in to add a comment</a></div>`;
        }

        textDiv.append(addCommentDiv);
    }

    contentDiv.appendChild(textDiv)

    if (loadImages) {
        contentDiv = addImagesToPopup(imageUrl, name, textDiv, contentDiv, addressFound)
    }

    containerDiv.appendChild(contentDiv);

    return containerDiv;
}

export function addImagesToPopup(imageUrl, name, textDiv, contentDiv, addressFound) {
    const hasImage = addressFound && imageUrl !== null && imageUrl !== undefined && imageUrl !== "";
    if (hasImage) {
        // Have the images already been added? 
        let images = contentDiv?.getElementsByTagName("img");
        let image = images ? images[0] : null;

        // if the image exists remove it
        if(image) {
            image.closest(".he-grid-col-5").remove(); 
        }

        // add/ remove correct classes 
        textDiv.classList.remove('he-grid-col-12');
        textDiv.classList.add('he-grid-col-7');
        
        // create the image div
        const imageDiv = document.createElement("div");
        const imageWrapper = document.createElement("div");
        imageWrapper.classList.add('ugc__map-popup-image-wrapper');
        imageWrapper.innerHTML = `<img src="${imageUrl}?autorotate=true&mode=crop&width=160&height=160&quality=60" alt="User-supplied image of ${name}" />`;
        imageDiv.appendChild(imageWrapper);
        imageDiv.classList.add('he-grid-col-5');
        contentDiv.appendChild(imageDiv);
    }

    return contentDiv; 
}